import React from 'react';
import { Card, Tabs, List, Button, Modal, Input, Form, message, Popconfirm, Tooltip, Empty, Spin } from 'antd';
import {
	PlusOutlined, EditOutlined, DeleteOutlined, ArrowUpOutlined, ArrowDownOutlined,
	SaveOutlined, FolderAddOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';
import Config from '../../Config';
import { apiClient } from '../../store/store';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ErrorAlertModal from '../../components/ErrorAlertModal';

// Alignment Quill dikonfigurasi pakai inline STYLE (bukan class ql-align-*)
// - HARUS SAMA PERSIS dgn allow-list sanitasi backend (dokumentasi/sanitize.py
// ALLOWED_STYLES = ['text-align']). Kalau ini tidak diregister, Quill
// default pakai class ql-align-center dll yang toh akan DIBUANG bleach
// (bukan di allow-list attributes) - hasilnya alignment kelihatan benar di
// editor tapi hilang lagi setelah disimpan+dibaca ulang.
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);

const { TabPane } = Tabs;
const configClass = {
	title: 'Edit Panduan Pengguna',
	apiUrl: {
		kategori: 'dokumentasi/api/kategori/',
		bagian: 'dokumentasi/api/bagian/',
		gambar: 'dokumentasi/api/gambar/',
	},
};
const config = new Config();

const QUILL_MODULES = {
	toolbar: {
		container: [
			[{ header: [1, 2, 3, false] }],
			['bold', 'italic', 'underline', 'strike'],
			[{ align: [] }],
			[{ list: 'ordered' }, { list: 'bullet' }],
			['link', 'image'],
			['clean'],
		],
		handlers: {}, // diisi per-instance (butuh akses this.imageHandler)
	},
};

class FormPanduan extends React.Component {
	quillRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			listKategori: [],
			activeTab: null,

			modalBagian: false, editingBagian: null, formJudul: '', formIsi: '',
			loadingSaveBagian: false,

			modalKategori: false, formKategoriNama: '', editingKategoriId: null,
			loadingSaveKategori: false,

			errTitle: '', errMsg: '',
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() { this.fetchData(); }

	fetchData = (keepTab) => {
		this.setState({ loading: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kategori)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const list = Array.isArray(data) ? data : (data.results || []);
					this.setState((prev) => ({
						listKategori: list,
						activeTab: keepTab && prev.activeTab ? prev.activeTab : (list.length ? String(list[0].id) : null),
					}));
				}
				this.setState({ loading: false });
			})
			.catch(() => this.setState({ loading: false }));
	};

	_showError = (title, fallback) => {
		const msg = this.props.responseMsg;
		const detail = msg && (msg.error || msg.detail);
		const errMsg = (typeof msg === 'string' ? msg : detail) || fallback;
		this.setState({ errTitle: title, errMsg });
	};

	// ───────────────────────── Kategori ─────────────────────────
	openTambahKategori = () => {
		this.setState({ modalKategori: true, editingKategoriId: null, formKategoriNama: '' });
	};

	openEditKategori = (kat) => {
		this.setState({ modalKategori: true, editingKategoriId: kat.id, formKategoriNama: kat.nama });
	};

	handleSaveKategori = () => {
		const { editingKategoriId, formKategoriNama, listKategori } = this.state;
		if (!formKategoriNama.trim()) {
			message.warning({ content: 'Nama kategori wajib diisi.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingSaveKategori: true });
		const isEdit = !!editingKategoriId;
		const url = isEdit ? `${configClass.apiUrl.kategori}${editingKategoriId}/` : configClass.apiUrl.kategori;
		const method = isEdit ? 'put' : 'post';
		const urutan = isEdit ? undefined : (listKategori.length + 1);
		const payload = { nama: formKategoriNama.trim(), ...(urutan ? { urutan } : {}) };
		this.props.ajaxHandler(method, url, payload, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Kategori tersimpan', duration: 2, key: 'toast' });
					this.setState({ modalKategori: false });
					this.fetchData(true);
				} else {
					this._showError('Gagal Menyimpan Kategori', 'Gagal menyimpan kategori.');
				}
				this.setState({ loadingSaveKategori: false });
			})
			.catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingSaveKategori: false }); });
	};

	handleHapusKategori = (kat) => {
		this.props.ajaxHandler('delete', `${configClass.apiUrl.kategori}${kat.id}/`, {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Kategori dihapus', duration: 2, key: 'toast' });
					this.fetchData(false);
				} else {
					this._showError('Gagal Menghapus', 'Gagal menghapus kategori - pastikan tidak ada bagian di dalamnya.');
				}
			})
			.catch(() => this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'));
	};

	// ───────────────────────── Bagian ─────────────────────────
	openTambahBagian = (kategoriId) => {
		this.setState({
			modalBagian: true, editingBagian: { kategori: kategoriId, isNew: true },
			formJudul: '', formIsi: '',
		});
	};

	openEditBagian = (bagian) => {
		this.setState({ modalBagian: true, editingBagian: bagian, formJudul: bagian.judul, formIsi: bagian.isi });
	};

	handleSaveBagian = () => {
		const { editingBagian, formJudul, formIsi, listKategori } = this.state;
		if (!formJudul.trim()) {
			message.warning({ content: 'Judul bagian wajib diisi.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingSaveBagian: true });
		const isNew = editingBagian.isNew;
		const kat = listKategori.find((k) => k.id === editingBagian.kategori);
		const urutan = isNew ? ((kat && kat.bagian ? kat.bagian.length : 0) + 1) : editingBagian.urutan;
		const payload = { kategori: editingBagian.kategori, judul: formJudul.trim(), isi: formIsi, urutan };
		const url = isNew ? configClass.apiUrl.bagian : `${configClass.apiUrl.bagian}${editingBagian.id}/`;
		const method = isNew ? 'post' : 'put';
		this.props.ajaxHandler(method, url, payload, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Bagian tersimpan', duration: 2, key: 'toast' });
					this.setState({ modalBagian: false, editingBagian: null });
					this.fetchData(true);
				} else {
					this._showError('Gagal Menyimpan Bagian', 'Gagal menyimpan bagian.');
				}
				this.setState({ loadingSaveBagian: false });
			})
			.catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingSaveBagian: false }); });
	};

	handleHapusBagian = (bagian) => {
		this.props.ajaxHandler('delete', `${configClass.apiUrl.bagian}${bagian.id}/`, {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Bagian dihapus', duration: 2, key: 'toast' });
					this.fetchData(true);
				} else {
					this._showError('Gagal Menghapus', 'Gagal menghapus bagian.');
				}
			})
			.catch(() => this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'));
	};

	// Tukar field 'urutan' dgn tetangga (naik/turun) - PATCH keduanya. Lebih
	// simpel drpd drag-and-drop utk kebutuhan reorder yang tidak sering.
	handleGeser = (kategoriId, index, arah) => {
		const kat = this.state.listKategori.find((k) => k.id === kategoriId);
		if (!kat) return;
		const list = [...kat.bagian];
		const targetIndex = index + arah;
		if (targetIndex < 0 || targetIndex >= list.length) return;
		const a = list[index], b = list[targetIndex];
		Promise.all([
			this.props.ajaxHandler('patch', `${configClass.apiUrl.bagian}${a.id}/`, { urutan: b.urutan }, false, true),
			this.props.ajaxHandler('patch', `${configClass.apiUrl.bagian}${b.id}/`, { urutan: a.urutan }, false, true),
		]).then(() => this.fetchData(true));
	};

	// ───────────────────────── Upload gambar (toolbar Quill) ─────────────────────────
	imageHandler = () => {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();
		input.onchange = async () => {
			const file = input.files[0];
			if (!file) return;
			const formData = new FormData();
			formData.append('file', file);
			message.loading({ content: 'Mengunggah gambar...', duration: 0, key: 'upload-gambar' });
			try {
				const token = Cookies.get(config.get_cookie_name());
				const res = await apiClient.post(configClass.apiUrl.gambar, formData, {
					headers: { Authorization: token || '' },
				});
				const url = res.data.file;
				const editor = this.quillRef.current.getEditor();
				const range = editor.getSelection(true);
				editor.insertEmbed(range ? range.index : 0, 'image', url);
				message.success({ content: 'Gambar berhasil diunggah', duration: 2, key: 'upload-gambar' });
			} catch (err) {
				const detail = err.response && err.response.data && (err.response.data.file || err.response.data.detail);
				message.error({ content: (Array.isArray(detail) ? detail[0] : detail) || 'Gagal mengunggah gambar.', duration: 3, key: 'upload-gambar' });
			}
		};
	};

	_quillModules = () => ({
		...QUILL_MODULES,
		toolbar: { ...QUILL_MODULES.toolbar, handlers: { image: this.imageHandler } },
	});

	render() {
		const {
			loading, listKategori, activeTab,
			modalBagian, formJudul, formIsi, loadingSaveBagian,
			modalKategori, formKategoriNama, editingKategoriId, loadingSaveKategori,
			errTitle, errMsg,
		} = this.state;
		const activeKat = listKategori.find((k) => String(k.id) === activeTab);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-panduan-wrap .ql-editor { min-height: 320px; font-size: 13.5px; }
						.form-panduan-wrap .ant-list-item { padding: 10px 4px; }
					`}</style>
				</Helmet>

				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card className="form-panduan-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847 0%, #1a3a6b 100%)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12,
					}}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
							<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10,
								display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>✏️</div>
							<div>
								<div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>{configClass.title}</div>
								<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Kelola kategori dan bagian panduan pengguna</div>
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Link to="/admin/panduan">
								<Button style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
									Lihat Panduan
								</Button>
							</Link>
							<Button
								icon={<FolderAddOutlined />}
								onClick={this.openTambahKategori}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								Tambah Kategori
							</Button>
						</div>
					</div>

					<div style={{ padding: 22 }}>
						{loading ? (
							<div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>
						) : listKategori.length === 0 ? (
							<Empty description="Belum ada kategori - klik Tambah Kategori" style={{ padding: 60 }} />
						) : (
							<Tabs
								activeKey={activeTab}
								onChange={(k) => this.setState({ activeTab: k })}
								tabBarExtraContent={activeKat && (
									<div style={{ display: 'flex', gap: 6 }}>
										<Tooltip title="Ganti nama kategori">
											<Button size="small" icon={<EditOutlined />} onClick={() => this.openEditKategori(activeKat)} />
										</Tooltip>
										<Popconfirm
											title="Hapus kategori ini? Semua bagian di dalamnya ikut terhapus."
											onConfirm={() => this.handleHapusKategori(activeKat)}
											okText="Hapus" okType="danger" cancelText="Batal"
										>
											<Tooltip title="Hapus kategori">
												<Button size="small" danger icon={<DeleteOutlined />} />
											</Tooltip>
										</Popconfirm>
									</div>
								)}
							>
								{listKategori.map((kat) => (
									<TabPane tab={kat.nama} key={String(kat.id)}>
										<Button
											type="dashed" icon={<PlusOutlined />} block
											style={{ marginBottom: 14, borderRadius: 8 }}
											onClick={() => this.openTambahBagian(kat.id)}
										>
											Tambah Bagian
										</Button>
										{(!kat.bagian || kat.bagian.length === 0) ? (
											<Empty description="Belum ada bagian" />
										) : (
											<List
												dataSource={kat.bagian}
												renderItem={(b, index) => (
													<List.Item
														actions={[
															<Tooltip title="Naik" key="up">
																<Button size="small" shape="circle" icon={<ArrowUpOutlined />} disabled={index === 0}
																	onClick={() => this.handleGeser(kat.id, index, -1)} />
															</Tooltip>,
															<Tooltip title="Turun" key="down">
																<Button size="small" shape="circle" icon={<ArrowDownOutlined />} disabled={index === kat.bagian.length - 1}
																	onClick={() => this.handleGeser(kat.id, index, 1)} />
															</Tooltip>,
															<Tooltip title="Edit" key="edit">
																<Button size="small" shape="circle" type="primary" ghost icon={<EditOutlined />}
																	onClick={() => this.openEditBagian(b)} />
															</Tooltip>,
															<Popconfirm key="hapus" title="Hapus bagian ini?" onConfirm={() => this.handleHapusBagian(b)} okText="Hapus" okType="danger" cancelText="Batal">
																<Tooltip title="Hapus">
																	<Button size="small" shape="circle" danger icon={<DeleteOutlined />} />
																</Tooltip>
															</Popconfirm>,
														]}
													>
														<span style={{ fontWeight: 600, color: '#0f2847' }}>{b.judul}</span>
														{b.updated_by_nama && (
															<span style={{ marginLeft: 10, fontSize: 11, color: '#94a3b8' }}>
																diubah oleh {b.updated_by_nama}
															</span>
														)}
													</List.Item>
												)}
											/>
										)}
									</TabPane>
								))}
							</Tabs>
						)}
					</div>
				</Card>

				{/* ── Modal Edit/Tambah Bagian ── */}
				<Modal
					title={formJudul ? `Edit: ${formJudul}` : 'Tambah Bagian Baru'}
					visible={modalBagian}
					onCancel={() => this.setState({ modalBagian: false })}
					footer={null}
					width="min(94vw, 900px)"
					destroyOnClose
				>
					<Form layout="vertical">
						<Form.Item label="Judul Bagian" required>
							<Input
								size="large"
								placeholder="mis. Bagian A: Pendaftaran Lama"
								value={formJudul}
								onChange={(e) => this.setState({ formJudul: e.target.value })}
							/>
						</Form.Item>
						<Form.Item label="Isi" required>
							<ReactQuill
								ref={this.quillRef}
								theme="snow"
								value={formIsi}
								onChange={(val) => this.setState({ formIsi: val })}
								modules={this._quillModules()}
							/>
						</Form.Item>
					</Form>
					<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
						<Button onClick={() => this.setState({ modalBagian: false })} style={{ borderRadius: 8 }}>Batal</Button>
						<Button
							type="primary" icon={<SaveOutlined />} loading={loadingSaveBagian}
							onClick={this.handleSaveBagian}
							style={{ borderRadius: 8, background: 'linear-gradient(135deg, #1e4d8a, #0f2847)', border: 'none', fontWeight: 600 }}
						>
							Simpan
						</Button>
					</div>
				</Modal>

				{/* ── Modal Tambah/Edit Kategori ── */}
				<Modal
					title={editingKategoriId ? 'Ganti Nama Kategori' : 'Tambah Kategori'}
					visible={modalKategori}
					onCancel={() => this.setState({ modalKategori: false })}
					footer={null}
					destroyOnClose
				>
					<Form layout="vertical" onFinish={this.handleSaveKategori}>
						<Form.Item label="Nama Kategori" required>
							<Input
								size="large"
								placeholder="mis. Petugas Penetapan"
								value={formKategoriNama}
								onChange={(e) => this.setState({ formKategoriNama: e.target.value })}
							/>
						</Form.Item>
						<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
							<Button onClick={() => this.setState({ modalKategori: false })} style={{ borderRadius: 8 }}>Batal</Button>
							<Button type="primary" htmlType="submit" loading={loadingSaveKategori} style={{ borderRadius: 8 }}>Simpan</Button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormPanduan);
